import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import { authModalReducer } from 'modules/auth';
import { privateTestReducer } from 'modules/blok-test';
import { confirmationModalReducer, heartModalReducer, loadingReducer, userReducer } from 'modules/global';

export const store = configureStore({
  reducer: {
    authModal: authModalReducer,
    heartModal: heartModalReducer,
    confirmationModal: confirmationModalReducer,
    user: userReducer,
    privateTest: privateTestReducer,
    routeLoading: loadingReducer,
  }
});

type RootStateType = ReturnType<typeof store.getState>;
type AppDispatchType = typeof store.dispatch;

export const useAppDispatch: () => AppDispatchType = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
